import React from "react";
import processData from "../assests/JSON/EinvProcess.json";
import "../styles/EinvProcess.css";

const EinvProcess = () => {
  return (
    <div className="einv-process-container">
      {/* <h2 className="einv-process-title">{processData.title}</h2>
      <p className="einv-process-description">{processData.description}</p>
      <ol className="einv-process-list">
        {processData.steps.map((step, index) => (
          <li key={index} className="einv-process-step">
            {step.split("\n").map((line, idx) => (
              <p key={idx} className="einv-line">
                {line}
              </p>
            ))}
          </li>
        ))}
      </ol> */}
      <div className="bottomImageWrapper">
        <img
          src={require(`../assests/images/${processData.imagePath}`)}
          alt="Process"
          className="bottom-image"
        />
      </div>
    </div>
  );
};

export default EinvProcess;
